<script lang="ts">
	import { geolocation } from "$lib/client/stores/nucamp-geolocation";
	import { getGeoLocation } from "$lib/client/services/community";
	import { onMount } from "svelte";
  import { isItBot } from "$lib/helpers";

  onMount(() => {
    // console.log('getting user IP');
    const isBot = isItBot();
    if (!isBot) {
      getGeoLocation()
      .then((location) => {
        if (location) geolocation.set(location);
      })
    }
  });
</script>